import { applyFontWeightNormal } from "../utilities/fonts";
import { applyCursorDefault } from "../utilities/cursor";
const styles = {
    paragraph: Object.assign(Object.assign({}, applyCursorDefault()), applyFontWeightNormal()),
    paragraph__1: {},
    paragraph__2: {},
    paragraph__3: {},
};
export default styles;
